import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import {
  DsListMenuItem,
  DsMenuModule,
  DsSearchBarComponent,
  DsSearchBarModule,
  DsTreeMenuItem,
} from '@levelaccess/design-system';

import { LauncherNavService } from '../../../../services/navigation/launcher-nav.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-switcher-content',
  templateUrl: './switcher-content.component.html',
  styleUrls: ['./switcher-content.component.scss'],
  standalone: true,
  imports: [AsyncPipe, SharedModule, DsSearchBarModule, DsMenuModule],
})
export class SwitcherContentComponent implements AfterViewInit {
  @ViewChild(DsSearchBarComponent) private searchBar: DsSearchBarComponent;

  public navItems$: Observable<DsTreeMenuItem[]>;
  public recentNavItems$: Observable<DsListMenuItem[]>;

  constructor(private launcherNavService: LauncherNavService) {
    this.navItems$ = this.launcherNavService.navItems$;
    this.recentNavItems$ = this.launcherNavService.recentNavItems$;
  }

  public ngAfterViewInit(): void {
    this.searchBar?.searchInput?.nativeElement?.focus();
  }

  public onSearch(value: string): void {
    this.launcherNavService.setSearchQuery(value);
  }
}
